import { useEffect, useRef, useState } from 'react';
import nyttroLogo from './assets/logo-dark.webp';
import templeDoors from './assets/temple-doors.png';
import './App.css';
import RegisterForm from './RegisterForm';

const ENTRY_STORAGE_KEY = 'nyttro-entry-opened';

function getInitialPhase() {
  try {
    return window.localStorage.getItem(ENTRY_STORAGE_KEY) === 'true' ? 'open' : 'closed';
  } catch {
    return 'closed';
  }
}

function TempleDoor({ side }) {
  return (
    <div className={`temple-door temple-door--${side}`} aria-hidden="true">
      <img className="door-photograph" src={templeDoors} alt="" fetchPriority="high" />
    </div>
  );
}

function App() {
  const [phase, setPhase] = useState(getInitialPhase);
  const registrationRef = useRef(null);

  useEffect(() => {
    if (phase === 'open') {
      registrationRef.current?.focus({ preventScroll: true });
      return;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const timer = phase === 'opening'
      ? window.setTimeout(() => setPhase('open'), 1800)
      : null;

    return () => {
      document.body.style.overflow = previousOverflow;
      window.clearTimeout(timer);
    };
  }, [phase]);

  const openDoors = () => {
    try {
      window.localStorage.setItem(ENTRY_STORAGE_KEY, 'true');
    } catch {
      // The entrance still works when browser storage is unavailable.
    }
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    setPhase(reduceMotion ? 'open' : 'opening');
  };

  return (
    <div className="App">
      <main
        className="registration"
        ref={registrationRef}
        tabIndex={-1}
        aria-label="Nyttro registration"
        hidden={phase === 'closed'}
        inert={phase !== 'open'}
        aria-hidden={phase !== 'open'}
      >
        <div className="brand-logo registration-logo">
          <img src={nyttroLogo} alt="Nyttro" />
        </div>
        <RegisterForm />
      </main>

      {phase !== 'open' && (
        <section className={`temple-entry temple-entry--${phase}`} aria-label="Welcome to Nyttro">
          <TempleDoor side="left" />
          <TempleDoor side="right" />
          <div className="temple-welcome">
            <p className="welcome-eyebrow">WELCOME</p>
            <div className="brand-logo welcome-logo">
              <img src={nyttroLogo} alt="Nyttro" />
            </div>
            <div className="welcome-rule" aria-hidden="true" />
            <h1>A new beginning.</h1>
            <p className="welcome-description"></p>
            <button className="enter-button" onClick={openDoors} disabled={phase === 'opening'}>
              {phase === 'opening' ? 'Opening the doors…' : 'Open the doors'}
              <span aria-hidden="true">→</span>
            </button>
            <p className="welcome-caption">NYTTRO · REGISTRATION</p>
          </div>
        </section>
      )}
    </div>
  );
}

export default App;
